import { render } from "./QC3AreaRetention.vue?vue&type=template&id=883cfb50"
import script from "./QC3AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC3AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC3AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "883cfb50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('883cfb50', __exports__)) {
    console.log('reload')
    api.reload('883cfb50', __exports__)
  }
  
  module.hot.accept("./QC3AreaRetention.vue?vue&type=template&id=883cfb50", () => {
    console.log('re-render')
    api.rerender('883cfb50', render)
  })

}


export default __exports__